import { Link } from 'react-router-dom';
import { CONTAINER_KIND_LABELS, containerOf } from '@cerebro-diem/core';
import type { ContainerRow } from '@cerebro-diem/core';
import { containerPath } from '../services/containers';

export const chipClass = 'px-2 py-0.5 rounded-full text-xs font-medium';

/**
 * A chip that is tapped (a link, or a person to add): a 44px pill with larger
 * text on a touch screen, the small chip under a mouse.
 */
export const chipButton =
  'inline-flex items-center gap-1 rounded-full font-medium min-h-11 px-3 text-sm pointer-fine:min-h-0 pointer-fine:px-2 pointer-fine:py-0.5 pointer-fine:text-xs';

/** Where an item lives, as a small link to that container: "Home", "Old job (archived)". */
export default function ContainerChip({
  item,
  containersById,
}: {
  item: { project_id?: string | null; area_id?: string | null; resource_id?: string | null };
  containersById: ReadonlyMap<string, ContainerRow>;
}) {
  const ref = containerOf(item);
  if (!ref) return null;
  const container = containersById.get(ref.id);
  return (
    <Link
      to={containerPath(ref.kind, ref.id)}
      title={CONTAINER_KIND_LABELS[ref.kind]}
      className={`${chipButton} max-w-full bg-surface-variant text-on-surface-variant hover:underline`}
    >
      {container ? container.name : CONTAINER_KIND_LABELS[ref.kind]}
      {container?.archived_at ? ' (archived)' : ''}
    </Link>
  );
}
